import { IAppState, TActions } from '../../../common/state';
import { INewbuilding } from '../../../types/newbuildingHeader';
import { SetNewbuildingComparisonStatusActionType } from '../actions';

const defaultState: INewbuilding | null = null;

export function newbuildingInformationReducer(state: IAppState, action?: TActions): IAppState {
  switch (action?.type) {
    case SetNewbuildingComparisonStatusActionType:
      if (!state.newbuildingInformation) {
        return state;
      }

      return {
        ...state,
        newbuildingInformation: {
          ...state.newbuildingInformation,
          comparisonStatus: action.comparisonStatus,
        },
      };
    default:
      return {
        ...state,
        newbuildingInformation: state.newbuildingInformation || defaultState,
      };
  }
}
